<template>
  <section class="admin-content" id="contact-search">
    <main class="admin-main">
      <section class="">
        <div class="col-md-12">
          <button
            class="btn btn-outline-dark"
            @click="filterparams = !filterparams"
          >
            filter Encounter
          </button>
        </div>

        <div class="mt-6">
          <div class="col-md-12">
            <div class="card" v-show="filterparams">
              <div class="card-header">
                <p class="text-center h4">Filter Parameter</p>
              </div>
              <div class="card-body">
                <div class="row">
                  <div
                    class="form-group col-md-12"
                    v-if="user.type == 'shis' || user.type == 'employee'"
                  >
                    <label> Select Facility </label>
                    <select class="form-control" v-model="provider_id">
                      <option
                        v-for="provider in providers"
                        v-bind:key="provider.id"
                        :value="provider.id"
                      >
                        {{ provider.agency_name }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group col-md-4">
                    <label for="inputCity"
                      ><i class="fe fe-calendar"></i> Start Date
                    </label>
                    <input type="date" class="form-control" v-model="from" />
                  </div>

                  <div class="form-group col-md-4">
                    <label for="inputCity"
                      ><i class="fe fe-calendar"></i> End Date
                    </label>
                    <input type="date" class="form-control" v-model="to" />
                  </div>

                  <div class="col-md-4">
                    <label for="">Rows</label>
                    <select class="form-control" v-model="paginate_value">
                      <option>30</option>
                      <option>100</option>
                      <option>500</option>
                      <option>1000</option>
                      <option>5000</option>
                      <option>10000</option>
                      <option>15000</option>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <button
                      class="btn btn-outline-info btn-block"
                      @click="getRecords"
                    >
                      Filter
                    </button>

                    <button class="btn btn-outline-info btn-block">
                      <download-excel
                        :data="records.data"
                        :fields="json_fields"
                        type="csv"
                        :escapeCsv="false"
                        :name="'encounter_data' + '.csv'"
                      >
                      </download-excel>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div
            class="row list"
            v-if="user.type == 'provider' || user.type == 'provider_employee'"
          >
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-header">
                  <p class="h4 my-3">
                    <span v-if="records.meta">{{ records.meta.total }}</span>
                    Encounters
                  </p>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>Encounter ID</th>
                          <th>Facility</th>
                          <th>Patient</th>
                          <th>Patient Phone Number</th>
                          <th>Diagnosis</th>

                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="encounter in records.data"
                          v-bind:key="encounter.id"
                        >
                          <td>
                            <span v-if="encounter.healthrecord != null">
                              {{ encounter.healthrecord.encounter_id }}
                            </span>
                          </td>
                          <td>
                            {{ encounter.provider.agency_name }}
                          </td>
                          <td>
                            <span v-if="encounter.enrollee != null">
                              {{ encounter.enrollee.full_name }}</span
                            >
                          </td>
                          <td>
                            <span v-if="encounter.enrollee != null">
                              {{ encounter.enrollee.phone_number }}</span
                            >
                          </td>
                          <td>
                            {{ encounter.diagnosis.name }}
                          </td>

                          <td>
                            <router-link
                              :to="{ path: '/encounter/' + encounter.id }"
                            >
                              <button
                                type="button"
                                class="btn btn-info mr-1"
                                name="button"
                              >
                                <i class="fe fe-eye"></i>
                              </button>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading
                :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"
              ></loading>
            </div>
          </div>

          <div
            class="row list"
            v-if="user.type == 'shis' || user.type == 'employee'"
          >
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="card row list">
                    <div class="card-header">
                      <button class="btn btn-outline-dark float-left">
                        {{ records.meta.total }} Encounters
                      </button>

                      <!-- <button
                        class="btn btn-outline-dark float-right"
                        @click="filterparams = !filterparams"
                      >
                        filters
                      </button> -->
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>Encounter ID</th>
                          <th>Patient</th>
                          <th>Facility</th>
                          <th>Reason for Visit</th>
                          <th>Medical Diagnosis</th>
                          <th>Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="record in records.data"
                          v-bind:key="record.id"
                        >
                          <td>
                            <span v-if="record.healthrecord != null">
                              {{ record.healthrecord.encounter_id }}
                            </span>
                          </td>
                          <td>
                            <span v-if="record.enrollee != null">
                              {{ record.enrollee.full_name }}
                            </span>
                          </td>
                          <td>
                            <span v-if="record.provider != null">
                              {{ record.provider.agency_name }}
                            </span>
                          </td>
                          <td>
                            <span v-if="record.healthrecord != null">
                              {{ record.healthrecord }}
                            </span>
                          </td>
                          <td>
                            <span v-if="record.diagnosis != null">
                              {{ record.diagnosis.name }}
                            </span>
                          </td>
                          <td>
                            {{
                              record.created_at | moment("dddd, MMMM Do YYYY")
                            }}
                          </td>
                          <router-link
                            :to="{ path: '/encounter/' + record.id }"
                          >
                            <button
                              type="button"
                              class="btn btn-info"
                              name="button"
                            >
                              <i class="fe fe-eye"></i>
                            </button>
                          </router-link>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading
                :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"
              ></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      filterparams: false,
      user: null,
      records: {
        data: "",
      },
      provider_id: "",
      providers: "",
      date: "",
      from: "",
      to: "",
      paginate_value: 30,
      json_fields: {
        "Encounter ID": "healthrecord.encounter_id",
        "Enrollee Full Name": "enrollee.full_name",
        "Enrollee AGENCY ID": "enrollee.id_card_number",
        "Enrollee Phone Number": "enrollee.phone_number",
        "Enrollee Place of Work": "enrollee.place_of_work",
        Diagnosis: "diagnosis.name",
        // secondary and other diagnoses, joined with "; " (service_summary-agency list)
        "Other Diagnoses": "other_diagnoses_text",
        "Facility Name": "provider.agency_name",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    addOneDay() {
      let result = new Date(this.to);
      result.setDate(result.getDate() + 1);
      return result;
    },
  },
  methods: {
    pushDate() {
      this.date = "date";
      this.getRecords();
    },
    getRecords() {
      this.user = JSON.parse(localStorage.getItem("user"));

      if (this.user.type == "provider_employee") {
        this.isLoading = true;

        this.axios
          .post(`/api/v1/auth/service_summary-agency`, {
            provider_id: this.user.institutional_id,
            agency_id: 90,
            paginate_value: this.paginate_value,
            from: this.from,
            to: this.to,
          })
          .then((response) => {
            this.records = response.data;
            this.isLoading = false;
            console.log(response);
            this.$toasted.info("Fetched Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      }

      if (this.user.type == "employee" || this.user.type == "shis") {
        this.isLoading = true;

        this.axios
          .post(`/api/v1/auth/service_summary-agency`, {
            agency_id: 90,
            provider_id: this.provider_id,
            paginate_value: this.paginate_value,
            date: this.date,
            from: this.from,
            to: this.addOneDay,
          })
          .then((response) => {
            this.records = response.data;
            this.isLoading = false;

            console.log(response);
            this.$toasted.info("Fetched Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      }
    },
    getProviders() {
      this.axios
        .get(`/api/v1/auth/providerAgency/90`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    copyText(record) {
      const copyToClipboard = (text) => navigator.clipboard.writeText(text);
      copyToClipboard(record.encounter_id);
      this.$toasted.info("Copied to clipboard", {
        position: "top-center",
        duration: 3000,
      });
    },
  },
  created() {
    this.getRecords();
    this.getProviders();
  },
};
</script>
